'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('int_voice_search/voiceSearch/voiceSearch'));
});
